export class GetProfessionalActivitiesTransactionsError extends Error {}
